import { StartupActionsApi } from '@agilelab/plugin-wb-startup-actions-common';
import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export const startupActionsApiRef: ApiRef<StartupActionsApi> = createApiRef({
  id: 'plugin.startup-actions.service',
});
